import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const SubtractCircle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00009 14.8713C11.7951 14.8713 14.8715 11.7949 14.8715 7.99985C14.8715 4.20486 11.7951 1.12842 8.00009 1.12842C4.20511 1.12842 1.12866 4.20486 1.12866 7.99985C1.12866 11.7949 4.20511 14.8713 8.00009 14.8713Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.82861 8H11.1715"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
